"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _FormattedDateTime = _interopRequireDefault(require("I18n/components/FormattedDateTime"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _Revisions = _interopRequireDefault(require("composer-lib/data/model/Revisions"));

var _constants = require("composer-lib/lib/constants");

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var prettifyDate = function prettifyDate(epochDateTime) {
  return _react.default.createElement(_FormattedDateTime.default, {
    value: epochDateTime,
    format: 'lll'
  });
};

var _default = (0, _createReactClass.default)({
  displayName: "RevisionsList",
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    revisions: _propTypes.default.instanceOf(_Revisions.default).isRequired,
    selectedRevision: _propTypes.default.number,
    selectRevision: _propTypes.default.func.isRequired
  },
  renderListItem: function renderListItem(_ref) {
    var updatedAt = _ref.updatedAt,
        user = _ref.user,
        id = _ref.id;
    var className = (0, _classnames.default)('revision-list-item', 'p-y-2', 'p-left-4', {
      selected: id === this.props.selectedRevision
    });
    return _react.default.createElement("div", {
      className: className,
      key: id,
      onClick: this.partial(this.props.selectRevision, id)
    }, _react.default.createElement(_UIIcon.default, {
      className: "revision-icon p-top-3 p-right-2",
      name: "file",
      size: 18
    }), _react.default.createElement("div", {
      className: "revision-meta display-inline-block"
    }, _react.default.createElement("div", null, prettifyDate(updatedAt)), _react.default.createElement(_Small.default, {
      use: "help"
    }, user.fullName)));
  },
  renderLoadingSpinner: function renderLoadingSpinner() {
    var revisions = this.props.revisions;

    if (revisions.get('objects').size === 0 || revisions.get('fetchStatus') !== _constants.RequestStatus.PENDING) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "revision-list-item"
    }, _react.default.createElement(_UILoadingSpinner.default, {
      layout: "centered"
    }));
  },
  renderList: function renderList() {
    return this.props.revisions.objects.map(this.renderListItem);
  },
  render: function render() {
    var className = (0, _classnames.default)(_constants.REVISIONS_LIST_CLASSNAME, 'p-bottom-5');
    return _react.default.createElement("div", {
      className: className
    }, this.renderList(), this.renderLoadingSpinner());
  }
});

exports.default = _default;
module.exports = exports.default;